import AboutPayLaterContainer from './AboutPayLaterContainer';

export default AboutPayLaterContainer;
